"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UniversalSearchResultsItem = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("@emotion/react");
const react_2 = require("react");
const react_i18next_1 = require("react-i18next");
const datetime_1 = require("../datetime");
const image_1 = require("../image");
const navigation_1 = require("../navigation");
const utils_1 = require("./utils");
const UniversalSearchResultsItem = props => {
    const linkBuilder = (0, navigation_1.useNavigationLinkBuilder)();
    const _memo = (0, react_2.useRef)({});
    const { t } = (0, react_i18next_1.useTranslation)();
    const link = (0, utils_1.buildRoute)(props);
    const anchorProps = linkBuilder(link);
    if ((0, utils_1.isItemSku)(props)) {
        if (_memo.current.ref !== JSON.stringify(props.values.properties)) {
            const value = ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "item-properties" }, { children: Object.entries(props.values.properties).map(([key, val]) => ((0, jsx_runtime_1.jsxs)("span", Object.assign({ className: "property-pill" }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ className: "property-key" }, { children: key })), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "property-val" }, { children: val }))] }), key))) })));
            _memo.current = { value, ref: JSON.stringify(props.values.properties) };
        }
        return ((0, jsx_runtime_1.jsxs)(Row, Object.assign({}, anchorProps, { children: [(0, jsx_runtime_1.jsx)(AccountLogoColumn, { visible: props.isAccountLogoVisible, accountLogo: props.accountLogo, accountName: props.accountName }), (0, jsx_runtime_1.jsx)(image_1.ImageFallback, { className: "item-sku-img", src: props.imageUrl || "/static/media/no-product-image.png", alt: t("common:productImage"), fallback: "no-product" }), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "item-main" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "item-header" }, { children: props.header })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "item-sub" }, { children: [(0, jsx_runtime_1.jsx)("b", { children: props.values.brandName }), " \u00B7 ", props.values.productName] })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "item-tertiary" }, { children: props.values.catSubCat }))] })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "item-aside" }, { children: _memo.current.value })), (0, jsx_runtime_1.jsx)(Chevron, {})] })));
    }
    if ((0, utils_1.isItemAsn)(props)) {
        return ((0, jsx_runtime_1.jsxs)(Row, Object.assign({}, anchorProps, { children: [(0, jsx_runtime_1.jsx)(AccountLogoColumn, { visible: props.isAccountLogoVisible, accountLogo: props.accountLogo, accountName: props.accountName }), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "item-main" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "item-header" }, { children: props.header })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "item-sub" }, { children: [props.values.shipperName, " \u00B7 ", props.values.unitLineString] }))] })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "item-aside" }, { children: [(0, jsx_runtime_1.jsx)(StatusBadge, { status: props.values.status }), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "item-meta-row" }, { children: [(0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { i18nKey: "common:poNumber" }), ": ", props.values.poNumber] })), props.values.expectedArrivalDate ? ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "item-meta-row" }, { children: [(0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { i18nKey: "common:expected" }), ":", " ", (0, jsx_runtime_1.jsx)(datetime_1.DateTime, { datetime: props.values.expectedArrivalDate })] }))) : null] })), (0, jsx_runtime_1.jsx)(Chevron, {})] })));
    }
    if ((0, utils_1.isItemOrder)(props)) {
        return ((0, jsx_runtime_1.jsxs)(Row, Object.assign({}, anchorProps, { children: [(0, jsx_runtime_1.jsx)(AccountLogoColumn, { visible: props.isAccountLogoVisible, accountLogo: props.accountLogo, accountName: props.accountName }), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "item-main" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "item-header" }, { children: props.header })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "item-sub" }, { children: [props.values.shipToName, " \u00B7 ", props.values.shipToCity, ", ", props.values.shipToLocale] })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "item-tertiary" }, { children: props.values.unitLineString }))] })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "item-aside" }, { children: [(0, jsx_runtime_1.jsx)(StatusBadge, { status: props.values.status }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "item-meta-row" }, { children: props.values.shipping })), props.values.submittedAt ? ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "item-meta-row" }, { children: (0, jsx_runtime_1.jsx)(datetime_1.DateTime, { datetime: props.values.submittedAt }) }))) : null] })), (0, jsx_runtime_1.jsx)(Chevron, {})] })));
    }
    if ((0, utils_1.isItemRma)(props)) {
        return ((0, jsx_runtime_1.jsxs)(Row, Object.assign({}, anchorProps, { children: [(0, jsx_runtime_1.jsx)(AccountLogoColumn, { visible: props.isAccountLogoVisible, accountLogo: props.accountLogo, accountName: props.accountName }), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "item-main" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "item-header" }, { children: props.header })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "item-sub" }, { children: [props.values.fromName, " \u00B7 ", props.values.fromCity, ", ", props.values.fromLocale] })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "item-tertiary" }, { children: props.values.unitLineString }))] })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "item-aside" }, { children: [(0, jsx_runtime_1.jsx)(StatusBadge, { status: props.values.status }), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "item-meta-row" }, { children: [(0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { i18nKey: "common:packageId" }), ": ", props.values.packageID] }))] })), (0, jsx_runtime_1.jsx)(Chevron, {})] })));
    }
    return null;
};
exports.UniversalSearchResultsItem = UniversalSearchResultsItem;
const getStatusClass = (status) => {
    switch (status) {
        case "backordered":
        case "shorted":
        case "partiallyShorted":
        case "under-investigation":
        case "onDock":
        case "receivingStarted":
        case "tendered":
        case "delivered":
            return "badge-warning";
        case "failed":
        case "undeliverable":
        case "deleted":
        case "deactivated":
        case "damaged":
            return "badge-danger";
        case "inTransit":
            return "badge-info";
        case "canceled":
            return "badge-neutral";
        default:
            return "badge-success";
    }
};
const StatusBadge = ({ status }) => ((0, jsx_runtime_1.jsx)("span", Object.assign({ className: `status-badge ${getStatusClass(status)}` }, { children: status })));
const Chevron = () => ((0, jsx_runtime_1.jsx)("svg", Object.assign({ width: "12", height: "12", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", className: "item-chevron" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M9 18l6-6-6-6" }) })));
const Row = ({ href, children, onClick, }) => ((0, jsx_runtime_1.jsx)("li", Object.assign({ css: rowStyles }, { children: (0, jsx_runtime_1.jsx)("a", Object.assign({ href: href, onClick: onClick, className: "universal-search-result-item" }, { children: children })) })));
const AccountLogoColumn = ({ visible, accountLogo, accountName, }) => visible ? ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "account-logo" }, { children: (0, jsx_runtime_1.jsx)(image_1.ImageFallback, { className: "rounded", src: accountLogo || "", alt: accountName, style: { maxWidth: 60 } }) }))) : null;
const rowStyles = (0, react_1.css) `
  & > a.universal-search-result-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    color: inherit;
    text-decoration: none;
    transition: background 100ms;

    &:hover { background: rgba(0,0,0,0.025); }
  }

  &:not(:last-of-type) {
    border-bottom: 0.5px solid rgba(0,0,0,0.06);
  }

  .item-main {
    flex: 1;
    min-width: 0;
  }
  .item-header {
    font-size: 13px;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .item-sub {
    font-size: 12px;
    color: rgba(0,0,0,0.5);
    margin-top: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .item-tertiary {
    font-size: 11px;
    color: rgba(0,0,0,0.35);
    margin-top: 1px;
  }
  .item-aside {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 3px;
    flex-shrink: 0;
    font-size: 11px;
    color: rgba(0,0,0,0.4);
  }
  .item-meta-row {
    white-space: nowrap;
  }
  .item-chevron {
    color: rgba(0,0,0,0.2);
    flex-shrink: 0;
  }

  .item-sku-img {
    width: 40px;
    height: 40px;
    object-fit: cover;
    border-radius: 6px;
    border: 0.5px solid rgba(0,0,0,0.08);
    flex-shrink: 0;
  }

  .account-logo {
    flex-shrink: 0;
  }
  .account-logo img {
    flex-shrink: 0;
  }

  .status-badge {
    font-size: 11px;
    padding: 2px 7px;
    border-radius: 8px;
    font-weight: 500;
    white-space: nowrap;

    &.badge-success { background: #EAF3DE; color: #27500A; }
    &.badge-info    { background: #E6F1FB; color: #0C447C; }
    &.badge-warning { background: #FAEEDA; color: #633806; }
    &.badge-danger  { background: #FCEBEB; color: #791F1F; }
    &.badge-neutral { background: rgba(0,0,0,0.05); color: rgba(0,0,0,0.5); }
  }

  .item-properties {
    display: flex;
    flex-direction: column;
    gap: 2px;
    align-items: flex-end;
  }
  .property-pill {
    font-size: 11px;
    color: rgba(0,0,0,0.5);
    white-space: nowrap;

    .property-key { color: rgba(0,0,0,0.35); }
    .property-val { margin-left: 4px; font-weight: 500; color: rgba(0,0,0,0.6); }
  }
`;
